export default __webpack_public_path__ + "static/media/ic-temp-warm.8193625c.svg";